import { ScaleLinear } from 'd3';

export interface TickValues {
  position: number;
  value: number;
}

export function generateTickValues(
  scale: ScaleLinear<number, number>,
  count?: number,
): TickValues[] {
  const ticks = scale.ticks(count);
  return ticks.map((d: number, i: number): TickValues => {
    let range = scale(d);
    // first and last tick can be off by one pixel, add or subtract one pixel
    if (i === 0) range -= 1;
    if (i === ticks.length - 1) {
      return {
        position: scale.range()[1]!,
        value: scale.domain()[1]!,
      };
    }
    return {
      position: range,
      value: d,
    };
  });
}
